import { Component, OnInit, Injector, ViewChild, TemplateRef, Input, Output, EventEmitter, Optional, ChangeDetectorRef, LOCALE_ID, Inject } from '@angular/core';
import {ExpireOperation, SendMessage} from '../time-limit-control.entity';
import { ExprEditMode, ExpressionService, InjectedType} from '@gsp-svc/expression';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDesignerUIState } from '../../../app/process-designer.uistate';
import { SmsMessageTemplate } from '../../sms-message-template/sms-message-template';
import { SmsMessageTemplateComponent } from '../../sms-message-template/sms-message-template.component';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-send-message-operation',
  templateUrl: './send-message-operation.component.html',
  styleUrls: ['./send-message-operation.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class SendMessageOperationComponent implements OnInit {

  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';
  @ViewChild('footer') footer: TemplateRef<any>;
  @ViewChild(SmsMessageTemplateComponent) SmsTemplate:SmsMessageTemplateComponent
  @Input()
  set value(info: SendMessage) {
    this.operation = JSON.parse(JSON.stringify(info));
    if (this.operation.sendType === undefined) {
      const sendMessage = new SendMessage(this.location,this.localePipe);
      this.operation.cycleEnable = sendMessage.cycleEnable;
      this.operation.cycleTimeUnit = sendMessage.cycleTimeUnit;
      this.operation.receiver = sendMessage.receiver;
      this.operation.subject = sendMessage.subject;
      this.operation.message = sendMessage.message;
    }
    if (this.operation.receiver && this.operation.receiver.length > 0) {
      let array = this.operation.receiver.split(',');
      if (array.indexOf('workItemParticipant') > -1) {
        this.receiverVari = 'workItemParticipant';
        this.activityReceiverVar += 'workItemParticipant,';
      }
      if (array.indexOf('procInstCreator') > -1) {
        this.receiverVari = 'procInstCreator';
        this.activityReceiverVar += 'procInstCreator,';
      }
      if (array.indexOf('preActExecutors') > -1){
        this.activityReceiverVar += 'preActExecutors,';
      }
      if(this.activityReceiverVar.length > 0){
        this.activityReceiverVar = this.activityReceiverVar.substring(0,this.activityReceiverVar.length-1);
      }
      if (array.length > 0) {
        array = array.filter(a => a !== 'procInstCreator');
        this.bindingData.id = '';
        for (const r of array) {
          this.bindingData.id += r + ',';
        }
        if (this.bindingData.id) {
          this.bindingData.id = this.bindingData.id.substring(0, this.bindingData.id.length - 1);
        }
      }
    }
    if (this.operation.receiverText && this.operation.receiverText.length > 0) {
      let array = this.operation.receiverText.split(',');
      if (array.length > 0) {
        array = array.filter(a => a !== '流程发起人');
        this.bindingData.name = '';
        for (const r of array) {
          this.bindingData.name += r + ',';
        }
        if (this.bindingData.name) {
          this.bindingData.name = this.bindingData.name.substring(0, this.bindingData.name.length - 1);
        }
      }
    }
    if (this.hasSmsMessage(this.operation.sendType)) {
      this.hasSmsTemplate = true;
      if (!this.operation.smsMessageTemplate) {
        this.operation.smsMessageTemplate = new SmsMessageTemplate();
      }
    }
  }

  get value() {
    return this.operation;
  }

  // operation: ExpireOperation = new ExpireOperation();
  operation: SendMessage = new SendMessage('activity',this.localePipe);
  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<ExpireOperation>();

  typeGroup = this.uistate.messageChannels.map(m => ({ value: m.code, name: m.name }));

  receiverVariables = [
    { value: 'procInstCreator', name: this.localePipe.transform("component.sendMessageOperation.procInstCreator") }
  ];
  activityReceiverVariables = [
    { value: 'workItemParticipant', name: this.localePipe.transform("component.sendMessageOperation.workItemParticipant")  },
    { value: 'procInstCreator', name: this.localePipe.transform("component.sendMessageOperation.procInstCreator")  },
    { value: 'preActExecutors', name: this.localePipe.transform("component.sendMessageOperation.preActExecutors") }
  ];

  placeholder = '';
  placeholder2 = '';

  hasSmsTemplate = false;

  parser = (val: string | number) => {
    // console.log(val);
    return Number(val);
  }

  timeUnitCollection = [
    { value: 'day', text: this.localePipe.transform("component.sendMessageOperation.day") },
    { value: 'hour', text: this.localePipe.transform("component.sendMessageOperation.hour") },
    { value: 'minute', text: this.localePipe.transform("component.sendMessageOperation.minute") }
  ];

  location: 'activity' | 'process' = 'activity';

  receiverVari: string;

  activityReceiverVar: string = '';

  bindingData: { id?, name?} = {};

  constructor(
    private injector: Injector,
    private message: MessagerService,
    private uistate: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    private expr: ExpressionService
  ) { }

  ngOnInit() {
  }

  contentExpr(data: any){
    this.showContentHelp(data);
  }

  titleExpr(data: any){
    this.showTitleHelp(data);
  }

  showContentHelp(data: string){
    const context = this.showExpr();
    if (this.operation.message && this.operation.message.length > 0) {
      if(!this.operation.message.startsWith("{\"" + "expr\"" + ":\"")) {
          this.expr.addExpressionText("\'" + this.operation.message + "\'");
      }else {
        this.expr.addExpressionText(this.operation.message);
      }
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      this.operation.message = expressionInfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  showTitleHelp(data: string) {
    const context = this.showExpr();
    if (this.operation.subject && this.operation.subject.length > 0) {
      if(!this.operation.subject.startsWith("{\"" + "expr\"" + ":\"")) {
        this.expr.addExpressionText("\'" + this.operation.subject + "\'");
      }else {
        this.expr.addExpressionText(this.operation.subject);
      }
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      this.operation.subject = expressionInfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  clickOK() {
    if (this.SmsTemplate) {
      this.SmsTemplate.endGridEdit();
    }
    this.operation.cycleTime += '';
    if (this.location === 'process') {
      this.setReceiver();
    }
    if(this.location === 'activity') {
      this.setActivityReceiver()
    }
    if (this.hasSmsTemplate) {
      this.operation.smsMessageTemplate = this.SmsTemplate.smsMessageTemplate;
      if (this.operation.smsMessageTemplate.smsMessageVariables && this.operation.smsMessageTemplate.smsMessageVariables.length > 0) {
        this.operation.smsMessageTemplate.smsMessageVariables = this.operation.smsMessageTemplate.smsMessageVariables.filter(variable => variable.code);
      }
    } else {
      this.operation.smsMessageTemplate = null;
    }
    if (this.validator()) {
      this.submitEmitter.emit(this.operation);
    }
  }

  clickCancel() {
    this.closeEmitter.emit();
  }

  clear() {
    this.bindingData = {};
  }

  sendTypeChange(sendType: string) {
    if (this.hasSmsMessage(sendType)) {
      this.hasSmsTemplate = true;
      if (!this.operation.smsMessageTemplate) {
        this.operation.smsMessageTemplate = new SmsMessageTemplate();
      }
    } else {
      this.hasSmsTemplate = false;
      this.operation.smsMessageTemplate = null;
    }
  }

  private setReceiver() {
    let receiver = '';
    let receiverText = '';
    if (this.receiverVari) {
      receiver += this.receiverVari + ',';
      const array = this.receiverVari.split(',');
      if (array.length > 0) {
        for (const a of array) {
          const t = this.receiverVariables.find(v => v.value === a).name;
          receiverText += t + ',';
        }
      }
    }
    if (this.bindingData.id) {
      receiver += this.bindingData.id + ',';
      receiverText += this.bindingData.name + ',';
    }
    if (receiver) {
      receiver = receiver.substring(0, receiver.length - 1);
    }
    if (receiverText) {
      receiverText = receiverText.substring(0, receiverText.length - 1);
    }
    this.operation.receiver = receiver;
    this.operation.receiverText = receiverText;
  }

  setActivityReceiver(){
    let receiver = '';
    if (this.activityReceiverVar) {
      receiver += this.activityReceiverVar + ',';
    }
    if (receiver) {
      receiver = receiver.substring(0, receiver.length - 1);
    }
    this.operation.receiver = receiver;
  }
  private validator(): boolean {
    // 2023-5-22 如果没有启用循环预警则不进行校验
    if (this.operation.cycleEnable) {
      if (this.operation.cycleTime === 'undefined') {
        this.message.info(this.localePipe.transform("component.sendMessageOperation.cycleTimeNotEmpty"));
        return false;
      }
    }
    if (!this.operation.sendType) {
      this.message.info(this.localePipe.transform("component.sendMessageOperation.sendMethodNotEmpty"));
      return false;
    }
    if (!this.operation.subject) {
      this.message.info(this.localePipe.transform("component.sendMessageOperation.subjectNotEmpty"));
      return false;
    }
    if (!this.operation.message) {
      this.message.info(this.localePipe.transform("component.sendMessageOperation.contentNotEmpty"));
      return false;
    }
    if (!this.operation.receiver) {
      this.message.info(this.localePipe.transform("component.sendMessageOperation.recipientNotEmpty"));
      return false;
    }
    //去除消息模板编号校验
    // if (this.hasSmsTemplate) {
    //   if (!this.operation.smsMessageTemplate) {
    //     this.message.info(this.localePipe.transform("component.sendMessageOperation.messageTemplate"));
    //     return false;
    //   }
    //   if (!this.operation.smsMessageTemplate.code) {
    //     this.message.info(this.localePipe.transform("component.sendMessageOperation.smsTemplateNumberNotEmpty"));
    //     return false;
    //   }
    // }
    return true;
  }

  private hasSmsMessage(sendType: string) {
    if (sendType) {
      const sendTypeList = sendType.split(',');
      let messageChannel = sendTypeList.find(val => this.uistate.messageChannels.find(channel => channel.code == val && channel.channelType == 'Sms'));
      if (messageChannel) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

  showExpr(){
    // this.expr.clearContext();
    if (this.uistate.schemas.length > 0) {
      for (const schema of this.uistate.schemas) {
        // this.expr.addCommonObject(co);
        this.expr.addSchema('Schema', schema);
      }
      if (this.uistate.schemas[0].entityTypes && this.uistate.schemas[0].entityTypes.length > 0) {
        const entityType = this.uistate.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.uistate.procInstContext.length > 0) {
      for (const variable of this.uistate.procInstContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (this.uistate.processVariableContext.length > 0) {
      for (const variable of this.uistate.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (this.uistate.subActivityContext.length > 0) {
      for (const variable of this.uistate.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    return context;
  }

}
